import React from "react";
import AboutHero from "./AboutHero";
import AboutStory from "./AboutStory";
import ServicesSection from "./ServicesSection";

function About() {
  return (
    <main>
      <AboutHero />
      <AboutStory />
      <ServicesSection />
    </main>
  );
}

export default About;